import { useToast } from "@kamae-apps/shared/old/Component/Toast/Context"
import { errorToast, successToast } from "@kamae-apps/shared/old/Component/Toast/ToastBuilder"
import { apiRequest } from "@kamae-apps/shared/utils"
import React, { useState } from "react"
import { CompanyData } from "../../../Companies"

export const useResetScoresModal = ({
  company,
  setDisplay,
}: {
  company: CompanyData
  setDisplay: React.Dispatch<React.SetStateAction<boolean>>
}) => {
  const [loading, setLoading] = useState(false)
  const [population, setPopulation] = useState("ALL")
  const [type, setType] = useState("ALL")
  const populations = ["ALL", "ADMIN", "USER"]
  const types = ["ALL", "ELEARNINGS", "CHALLENGES", "PHISHINGS", "SPECIAL_EVENTS"]
  const toast = useToast()

  const resetScores = (population: string, type: string) => {
    setLoading(true)
    apiRequest("/companies/" + company.id + "/reset-scores?population=" + population + "&type=" + type, {
      method: "POST",
    })
      .then(() => {
        setLoading(false)
        setDisplay(false)
        toast.addToast(successToast("Reset réalisé, vous pouvez lancer le recalcul des scores"))
      })
      .catch(err => {
        setLoading(false)
        toast.addToast(errorToast(`Erreur lors du reset : ${err.message}`))
      })
  }

  return {
    loading,
    populations,
    types,
    population,
    type,
    setPopulation,
    setType,
    resetScores,
  }
}
